<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="security" ></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign5.png"> 修改密码</span></h2>
              <!--<div v-show="showNow==='userName'">-->
                <!--<div class="personal_right_tit" style="font-size: 14px"><a href="javascript:void(0)" class="tab_on">设置用户名</a><a href="javascript:void(0)" @click="()=>{this.showNow='passWord'}">重置密码</a></div>-->
                <!--<dl class="safe" style="padding-left: 13%;">-->
                  <!--<dd><span>用户名：</span><em><input :disabled="user_info.userNikeName!==user_info.userTel" v-model="temp_user_name" type="text" placeholder="请输入">-->
                  <!--<label>备注：用户名设置后将不可修改</label>-->
                  <!--</em></dd>-->
                  <!--<dd class="safe_button" v-if="user_info.userNikeName===user_info.userTel" style="margin-top: 10px;">-->
                    <!--<button @click="updateUserNikeName">确定</button>-->
                  <!--</dd>-->
                <!--</dl>-->
              <!--</div><a href="javascript:void(0)" @click="()=>{this.showNow='userName'}">设置用户名</a>-->
              <div v-show="showNow==='passWord'">
                <div style="height: 30px">&nbsp;</div>
                <el-steps :active="stepNow" space="25%" align-center>
                  <el-step style="font-size: 10px">
                    <template slot="title">
                      <span style="font-size:10px">用户验证</span>
                    </template>
                    <template slot="description">
                      <span style="font-size:10px"></span>
                    </template>
                  </el-step>
                  <el-step style="font-size: 10px">
                    <template slot="title">
                      <span style="font-size:10px">设置新密码</span>
                    </template>
                    <template slot="description">
                      <span style="font-size:10px"></span>
                    </template>
                  </el-step>
                  <el-step style="font-size: 10px">
                    <template slot="title">
                      <span style="font-size:10px">密码重置成功</span>
                    </template>
                    <template slot="description">
                      <span style="font-size:10px"></span>
                    </template>
                  </el-step>
                </el-steps>
          <!--  用户验证-->
                <dl v-if="stepNow===1" class="safe" style="width:54%;padding-left:8%;margin-top: 20px;">
                  <dd><span style="width:30%;"><img src="../../../static/images/required.png"> 手机号码：</span>
                    <em style="width:65%;"><input v-model="phone_number" type="text" placeholder="请输入手机号码"></em></dd>
                  <dd><span style="width:30%;"><img src="../../../static/images/required.png"> 短信验证码：</span>
                    <em  style="width:65%;">
                      <div style="width:97%;border:1px solid #dbdbdb; padding:0 3% 0 0;display:flex; justify-content: space-between;">
                        <input v-model="verify_code" style="border:none" type="text" placeholder="请输入短信验证码">
                        <span style="font-size: 10px;cursor: pointer" :class="this.time_interval>1?'disabled':'available'" @click="getCode">{{show_get_text}}</span>
                      </div>
                    </em>
                  </dd>
                  <dd class="safe_button">
                    <button @click="checkVerifyCode">下一步</button>
                  </dd>
                </dl>
          <!-- 设置密码-->
                <dl v-else-if="stepNow===2" class="safe" style="width:54%;padding-left:8%;margin-top: 20px;">
                  <dd><span><img src="../../../static/images/required.png"> 新密码：</span><em><input  v-model="new_password" type="password" placeholder="请输入新密码"></em></dd>
                  <dd><span><img src="../../../static/images/required.png"> 确认密码：</span><em><input v-model="new_password_again" type="password" placeholder="请再次输入新密码"></em></dd>
                  <dd class="safe_button">
                    <button @click="updatePassword">确定</button>
                  </dd>
                </dl>
           <!-- 设置成功-->
                <dl v-else class="safe">
                  <dd><span style="color:#2c62ec;">密码重置成功</span></dd>
                </dl>
              </div>
              <el-dialog
                title="密码重置成功"
                :visible.sync="password_success"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="400px"
                top="35vh"
                center>
                <div style="width: 100%;text-align: center">
                  <span>{{password_success_text}}</span>
                </div>
                <span slot="footer" class="dialog-footer">
                        <el-button type="success" @click="gotoFirst">立即前往</el-button>
                    </span>
              </el-dialog>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "Security",
    components: {
      headers, fixedDiv, footers,personal
    },
    data(){
      return{
        showNow:'passWord',
        stepNow:1,   //重置密码布置1 2 3
        password_success:false,
        password_success_text:'5S 后即将前往首页',

        //控制获取验证码
        interval:null,
        time_interval:0,  //剩余时间间隔
        get_code_time:0 ,  //已获取验证码次数
        show_get_text:'发送短信',  //获取验证码按钮显示内容

        //用户输入信息
        phone_number:'',
        verify_code:'',
        new_password:'',
        new_password_again:'',

        user_info:{},
        temp_user_name:'',//用来缓存用户输入的用户名
        loginShow:false,
        gotoIndex:false,
      }
    },
    created() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getUserInfo()
      console.log(this.$cookies.get("userInfo"))
    },
    methods:{
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      } ,
      //获取用户信息
      getUserInfo(){
        this.$https.post("/api/pu/peopleUserInfo.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)){
              this.user_info = response.data.data;
              this.temp_user_name=this.user_info.userNikeName
            }
          }
        });
      },
      //修改用户名
      updateUserNikeName(){
        //用户名不能为空
        if (this.$util.isEmpty(this.temp_user_name)){
          this.$message({
            showClose: true,
            message: '用户名不能为空',
            type: 'error'
          });
          return
        }
        //新旧用户名不能相同
        if (this.temp_user_name===this.user_info.userNikeName){
          this.$message({
            showClose: true,
            message: '新旧用户名不能相同',
            type: 'error'
          });
          return
        }
        //向后端发请求修改用户名
        this.$https.post("/api/pu/updateUserNikeName.do", {new_nikeName:this.temp_user_name}, response => {
          if (response.status === 200 && response.data.code === 200) {
            //将新的用户名放入缓存
            let userInfo = this.$cookies.get("userInfo");
            if (!this.$util.isEmpty(userInfo)){
              userInfo.userName = this.temp_user_name;
              this.$cookies.set("userInfo",userInfo)
            }
            //重新加载页面
            this.$router.go(0)
          }
        });
      },

      //前往首页
      gotoFirst(){
        this.password_success=false;
        this.$router.replace({path:'/home'})
      },
      openPasswordSuccessDialog(){
        this.password_success=true;
        let time_left = 5;
        let interval = setInterval(()=>{
          if (time_left<=1){
            clearInterval(interval);
            this.gotoFirst()
          }else {
            time_left--;
            this.password_success_text=`${time_left}S 后即将前往首页`
          }
        },1000)
      },
      getCode(){
        if (this.time_interval<=1){
          //校验手机号码
          if (this.$util.validate.phone(this.phone_number)){
            this.time_interval=60;
            this.interval=setInterval(()=>{
              if (this.time_interval<=1){
                this.show_get_text='重新获取';
                clearInterval(this.interval)
              }else{
                this.time_interval--;
                this.show_get_text=`${this.time_interval}S`
              }
            }, 1000);
            //发送请求，获取验证码
            this.$https.post("/api/pu/getTelCode.do", {tel:this.phone_number}, response => {});
          }else {
            this.$message({
              showClose: true,
              message: '请正确的输入手机号',
              type: 'error'
            });
          }
        }
      },
      checkVerifyCode(){
        //校验手机号，验证码
        if (!this.$util.validate.phone(this.phone_number)){
          this.$message({
            showClose: true,
            message: '请输入正确的手机号',
            type: 'error',
          });
          return
        }
        if (this.$util.isEmpty(this.verify_code)){
          this.$message({
            showClose: true,
            message: '请输入验证码',
            type: 'error'
          });
          return;
        }
        //发送请求，校验验证码
        this.$https.post("/api/pu/checkTelCode.do", {tel:this.phone_number,code:this.verify_code}, response => {
          if (response.status === 200) {
            if (response.data.code === 200){
              this.stepNow=2
            }else {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: 'error'
              });
            }
          }
        });
      },
      updatePassword(){
        let pattern=/^(\w){6,20}$/;
        // if (!pattern.exec(this.password)){
        //   this.alertMsg='登录密码只能由6-20位字母、数字、下划线组成';
        // }
        //校验密码
        if (this.$util.isEmpty(this.new_password)){
          this.$message({
            showClose: true,
            message: '请输入新密码',
            type: 'error'
          });
          return;
        }
        if (!pattern.exec(this.new_password)){
          // this.alertMsg='登录密码只能由6-20位字母、数字、下划线组成';
          this.$message({
            showClose: true,
            message: '登录密码只能由6-20位字母、数字、下划线组成',
            type: 'error'
          });
          return;
        }
        if (this.$util.isEmpty(this.new_password_again)){
          this.$message({
            showClose: true,
            message: '请输入确认密码',
            type: 'error'
          });
          return;
        }
        //密码长度
        // if (!pattern.exec(this.new_password)){
        //   this.$message({
        //     showClose: true,
        //     message: '登录密码只能由6-20位字母、数字、下划线组成',
        //     type: 'warning'
        //   });
        //   return;
        // }
        if (this.new_password!==this.new_password_again){
          this.$message({
            showClose: true,
            message: '两次密码输入不一致，请检查您的输入',
            type: 'error'
          });
          return;
        }
        //向后端发送请求，重置密码
        this.$https.post("/api/pu/updatePassword.do", {password:this.new_password,qrpassword:this.new_password_again,usertel:this.phone_number}, response => {
          if (response.status === 200) {
            if (response.data.code === 200){
              this.stepNow=3;
              this.openPasswordSuccessDialog();
            }else {
              this.$message({
                showClose: true,
                message:response.data.msg,
                type: 'error'
              });
            }
          }
        });
      }
    }
  }
</script>

<style scoped>
  .disabled{
    color: #dbdbdb;
  }
  .available{
    color:#2c62ec;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/Security.vue